import EArtworkContent from "./EArtworkContent";
import EArtworkSidebar from "./EArtworkSidebar";

export default function ArtworkTabLayout({ activeTab, setActiveTab }) {
  /* ******************** All States ************************* */

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div className="inbox-root d-flex" style={{ height: "100vh" }}>
      <>
        <aside
          className="bg-white border-end"
          style={{ minWidth: 400, width: "400px" }}
        >
          <EArtworkSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        </aside>
      </>
      <main className="flex-grow-1">
        {/* <div
          className="card custom-border-radius p-2"
          style={{
            height: "98vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        > */}
        <EArtworkContent />
        {/* </div> */}
      </main>
    </div>
  );
}
